<template>
  <div class="color-sample n2-west2">
    <section />
    <section class="flex center grow column">
      <p class="box default-text">
        武皇嘯厚大禅門
      </p>
      <p class="box default-text">
        武皇嘯厚大禅門
      </p>
    </section>
    <section />
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
  },
  mounted () {},
  data () {
    return {
    };
  },
  computed: {
  },
  watch: {},
  destroyed () {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";
@import "~@/assets/styles/tablet-front.scss";
</style>
